<template>
  <div>
    <div
      v-for="(i, k) in timeOfWorkIds"
      :key="k"
      class="row"
    >
      <div class="col-md-12 col-sm-12">
        <label
          v-if="k === 0"
          :for="`work-time-${k}`">Время проведения работ</label>
        <label :for="`work-time-${k}`" v-else></label>
        <TimeOfWorkItem
          :key="k"
          :number="k"
          :timeOfWorkValues="timeOfWork"
          :timeOfWork="timeOfWorkIds[k]"
          :setWorkTime="setWorkTime"
          :addWorkTime="addWorkTime"
          :removeWorkTime="removeWorkTime"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TimeOfWorkItem from './TimeOfWorkItem'

export default {
  components: {
    TimeOfWorkItem
  },

  props: {
    timeOfWorkIds: {
      type: Array,
      default: () => []
    },
    timeOfWork: {
      type: Object
    }
  },

  mounted () {
    if (!this.timeOfWorkIds.length) {
      this.addWorkTime()
    }
  },

  methods: {
    addWorkTime () {
      this.timeOfWorkIds.push(Number(Object.keys(this.timeOfWork)[0]))
    },

    removeWorkTime (index) {
      this.timeOfWorkIds.splice(index, 1)
    },

    setWorkTime (index, value) {
      value = Number(value)
      this.timeOfWorkIds[index] = value
    }
  }
}
</script>
